import React, { useCallback, useEffect, useState } from 'react';
import {
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Chart as ChartJS,
  registerables,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { getChartGrossProfit } from 'services/gross-profit-report.service';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  ...registerables,
);

const ChartReport = () => {
  const [dataChart, setDataChart] = useState([]);
  const loadData = useCallback(() => {
    getChartGrossProfit().then(setDataChart);
  }, []);
  useEffect(loadData, [loadData]);

  console.log(dataChart);
  const data = {
    labels: dataChart?.map((e) => e?.month),
    datasets: [
      {
        yAxisID: 'T',
        type: 'line',
        label: 'Lãi gộp',
        data: dataChart?.map((e) => e?.profit_margin),
        backgroundColor: ['#EC2D41'],
        borderColor: ['#EC2D41'],
        borderWidth: 2,
        tension: 0.5,
      },
      {
        yAxisID: 'P',
        type: 'line',
        label: '% Biên lợi nhuận',
        data: dataChart?.map((e) => e?.profit_margin_ratio),
        backgroundColor: ['#175db8'],
        borderColor: ['#175db8'],
        borderWidth: 2,
        tension: 0.5,
      },
      {
        yAxisID: 'T',
        type: 'bar',
        label: 'Doanh thu',
        data: dataChart?.map((e) => e?.revenue),
        backgroundColor: ['rgba(0, 153, 130, 0.3)'],
        borderColor: ['#009981'],
        borderWidth: 1,
      },
    ],
  };
  const myChart = {
    options: {
      scales: {
        T: {
          type: 'linear',
          display: true,
          position: 'left',
          beginAtZero: true,
        },
        P: {
          type: 'linear',
          display: true,
          position: 'right',
          beginAtZero: true,
          color: '#175db8',
          grid: {
            drawOnChartArea: false,
          },
        },
      },
    },
  };
  return (
    <div>
      <Chart id='bw_char_turnover' options={myChart?.options} data={data} />
    </div>
  );
};

export default ChartReport;
